/** Acronyms that should display in all caps (e.g. rfid -> RFID, pos -> POS) */
const ACRONYMS = ['rfid', 'pos', 'sms', 'ocpi']

/**
 * Format start method for display: acronyms in caps (RFID, POS), rest in Title Case (Plug and Charge).
 * e.g. "rfid" -> "RFID", "pos" -> "POS", "plug_and_charge" -> "Plug and Charge"
 */
export function formatStartMethodDisplay(method: string): string {
  if (!method || typeof method !== 'string') return ''
  return method
    .split('_')
    .map((word) =>
      ACRONYMS.includes(word.toLowerCase()) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ')
}
